import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Link } from '@inertiajs/react'
import { AppLayout } from '@/components/layouts/AppLayout'

interface BoardSummary {
  id: number
  name: string
  slug: string
  color: string | null
  task_count: number
  member_count: number
  my_role: 'admin' | 'member' | null
  created_at: string
}

interface Props {
  boards: BoardSummary[]
}

export default function Index({ boards }: Props) {
  return (
    <AppLayout
      title="Boards"
      action={
        <Button component={Link} href="/tasks/boards/new" variant="contained">
          New board
        </Button>
      }
    >
      {boards.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 8 }}>
          No boards found. Create your first board to get started.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {boards.map((board) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={board.id}>
              <Card
                component={Link}
                href={`/tasks/boards/${board.slug}`}
                elevation={0}
                sx={{
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 2,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  textDecoration: 'none',
                  color: 'inherit',
                  cursor: 'pointer',
                  '&:hover': {
                    borderColor: 'text.secondary',
                    backgroundColor: 'grey.50',
                  },
                }}
              >
                <Box sx={{ height: 4, backgroundColor: board.color || '#6B7280', borderRadius: '8px 8px 0 0' }} />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h3" sx={{ mb: 1.5 }}>
                    {board.name}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Chip
                      label={`${board.task_count} task${board.task_count !== 1 ? 's' : ''}`}
                      size="small"
                      variant="outlined"
                    />
                    <Chip
                      label={`${board.member_count} member${board.member_count !== 1 ? 's' : ''}`}
                      size="small"
                      variant="outlined"
                    />
                    {board.my_role && (
                      <Chip
                        label={board.my_role}
                        size="small"
                        color={board.my_role === 'admin' ? 'secondary' : 'default'}
                        variant="outlined"
                      />
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </AppLayout>
  )
}
